export const aboutData = {
  brand: {
    title: "关于 17.c 起草官网",
    subtitle: "专业文件起草与官网建设一站式服务平台",
    intro: "17.c 起草官网成立于2015年，总部位于北京，是国内领先的专业文件起草与官方网站建设一站式服务平台。十年来，我们始终秉持专业、规范、高效、诚信的服务理念，为超过5000家企业客户提供了优质的文件起草和官网建设服务。",
    mission: "我们的使命是让每一家企业都能拥有专业规范的法律文件和品牌官网，助力中国企业提升合规水平和线上影响力。",
    vision: "成为国内最受信赖的文件起草与官网建设服务平台，用专业服务为企业创造价值。",
    values: [
      { title: "专业至上", desc: "汇聚法律、商务、技术领域资深专家，确保每项服务的专业品质" },
      { title: "客户为本", desc: "深入了解客户需求，提供量身定制的解决方案" },
      { title: "效率为先", desc: "标准化流程和高效协作，确保快速响应和及时交付" },
      { title: "诚信经营", desc: "价格透明公开，服务承诺兑现，建立长期信任关系" },
    ],
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20professional%20Chinese%20office%20interior%20with%20elegant%20design%2C%20warm%20natural%20lighting%20through%20large%20windows%2C%20team%20collaborating%20around%20a%20minimalist%20wooden%20table%2C%20sophisticated%20business%20atmosphere%2C%20warm%20cream%20and%20gold%20tones%2C%20refined%20editorial%20photography%20style%20with%20clean%20composition&width=800&height=600&seq=about-brand-01&orientation=landscape",
  },
  timeline: [
    { year: "2015", event: "公司成立，专注于文件起草服务" },
    { year: "2016", event: "服务客户突破500家，团队扩展至30人" },
    { year: "2017", event: "拓展官网建设业务，推出文件+网站一体化服务" },
    { year: "2019", event: "服务客户突破2000家，成立法律顾问委员会" },
    { year: "2021", event: "全面升级数字化服务平台，实现在线协作起草" },
    { year: "2023", event: "服务客户突破5000家，累计起草文件超过20000份" },
    { year: "2025", event: "获评行业领先品牌，客户满意度持续保持98%以上" },
  ],
  credentials: [
    { icon: "ri-award-line", title: "行业领先品牌", desc: "连续三年获评文件起草服务行业领先品牌" },
    { icon: "ri-verified-badge-line", title: "持证法律顾问", desc: "所有法律文件均由持证法律顾问审核把关" },
    { icon: "ri-customer-service-2-line", title: "5000+企业信赖", desc: "超过5000家企业客户的共同选择" },
    { icon: "ri-shield-star-line", title: "信息安全认证", desc: "通过ISO 27001信息安全管理体系认证" },
  ],
  team: [
    {
      name: "陈明远",
      role: "创始人 & CEO",
      desc: "前知名律师事务所合伙人，15年法律及企业管理经验",
      avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20in%20his%2040s%2C%20confident%20expression%2C%20modern%20office%20background%2C%20warm%20natural%20lighting%2C%20clean%20sophisticated%20portrait%20photography&width=200&height=200&seq=team-chen&orientation=squarish",
    },
    {
      name: "林晓华",
      role: "首席法律顾问",
      desc: "法学博士，10年以上商业法律实务经验，专注合同法与企业合规",
      avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20lawyer%20in%20her%2030s%2C%20elegant%20professional%20attire%2C%20confident%20and%20approachable%20expression%2C%20legal%20office%20background%2C%20warm%20natural%20lighting&width=200&height=200&seq=team-lin&orientation=squarish",
    },
    {
      name: "赵文博",
      role: "技术总监",
      desc: "前互联网大厂技术负责人，8年网站架构与SEO优化经验",
      avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20tech%20executive%20in%20his%2030s%2C%20modern%20casual%20professional%20look%2C%20creative%20workspace%20background%2C%20warm%20natural%20lighting%2C%20friendly%20confident%20expression&width=200&height=200&seq=team-zhao&orientation=squarish",
    },
  ],
};